import {AfterViewInit, Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from '../../base.component';
import {RouteUtil} from '../../../util/route.util';
import {Config} from '../../../common/config';

@Component({
  selector: 'app-footer-client',
  standalone: false,
  templateUrl: './footer-client.component.html',
  styleUrl: './footer-client.component.scss'
})
export class FooterClientComponent extends BaseComponent implements OnInit, AfterViewInit {
  protected readonly Config = Config;
  protected readonly RouteUtil = RouteUtil;

  constructor(injector: Injector) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
  }

  onLoginClicked() {
    this.router.navigate([RouteUtil.COMMON_MODULE, RouteUtil.SIGN_IN_COMPONENT]).then();
  }

  onHomeClicked() {
    if (Config.branch.UniqueIdentifier && Config.branch.UniqueIdentifier !== '') {
      this.router.navigate([RouteUtil.CLIENT_MODULE, RouteUtil.MENU_COMPONENT, Config.branch.UniqueIdentifier]).then();
    } else {
      this.router.navigate([RouteUtil.CLIENT_MODULE]).then();
    }
  }

  onPackagesClicked() {
    if (Config.branch.UniqueIdentifier && Config.branch.UniqueIdentifier !== '') {
      this.router.navigate([RouteUtil.CLIENT_MODULE, RouteUtil.LANDING_COMPONENT, Config.branch.UniqueIdentifier]).then();
    } else {
      this.router.navigate([RouteUtil.CLIENT_MODULE]).then();
    }
  }

  onBasketClicked() {
    if (Config.branch.UniqueIdentifier && Config.branch.UniqueIdentifier !== '') {
      this.router.navigate([RouteUtil.CLIENT_MODULE, RouteUtil.BASKET_COMPONENT, Config.branch.UniqueIdentifier]).then();
    } else {
      this.router.navigate([RouteUtil.CLIENT_MODULE]).then();
    }
  }

  onOrdersClicked() {
    if (Config.branch.UniqueIdentifier && Config.branch.UniqueIdentifier !== '') {
      this.router.navigate([RouteUtil.CLIENT_MODULE, RouteUtil.ORDERS_COMPONENT, Config.branch.UniqueIdentifier]).then();
    } else {
      this.router.navigate([RouteUtil.CLIENT_MODULE]).then();
    }
  }

  onProfileClicked() {
    this.router.navigate([RouteUtil.COMMON_MODULE, RouteUtil.ACCOUNT_COMPONENT]).then();
  }

  onSocialMedialClicked(social: any) {
    window.open(social.URI, '_blank');
  }
}
